import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class ImgTextBlocks {
	constructor(elm) {
		this.elm = elm;
		this.left = this.elm.querySelector('.m-img-text-blocks__column--left');
		this.right = this.elm.querySelector('.m-img-text-blocks__column--right');

		const mm = gsap.matchMedia();

		mm.add('(min-width: 768px)', () => {
			this.trigger = ScrollTrigger.create({
				trigger: this.left,
				start: 'top-=80 top',
				// Sticky-afstand: het hoogteverschil tussen de kolommen
				end: () => `+=${Math.max(0, this.right.offsetHeight - this.left.offsetHeight)}`,
				pin: this.left,
				pinSpacing: false,
			});
		});
	}

	destroy() {
		this.trigger?.kill();
	}
}
